module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_8003.aefd4ccb.png";